import { render } from "./ProspectionView.vue?vue&type=template&id=6188df15"
import script from "./ProspectionView.vue?vue&type=script&lang=js"
export * from "./ProspectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__